import { useDispatch } from "react-redux";
import { unselectQuestion } from "@/services/quiz";

export const useCloseQuestionDetails = () => {
    const dispatch = useDispatch();

    return () => dispatch(unselectQuestion());
};
